import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useApplyCoupon } from "../../cart/hooks/useApplyCoupon";

const CheckoutApplyCouponForm: React.FC = () => {
  const { t } = useTranslation();
  const [couponCode, setCouponCode] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);

  const { handleApplyCoupon, isApplying } = useApplyCoupon();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!couponCode.trim() || isApplying) return;

    const result = await handleApplyCoupon({ code: couponCode });

    if (result.success) {
      setCouponCode("");
      setIsExpanded(false); // Close the form on success
    }
  };

  return (
    <div className="checkout-coupon">
      <div className="checkout-coupon__toggle">
        <span>{t("cartApplyCouponForm.title", "Have a coupon?")}</span>{" "}
        <button
          type="button"
          className="checkout-coupon__toggle-btn"
          onClick={() => setIsExpanded(!isExpanded)}
          aria-expanded={isExpanded}
        >
          {t(
            "checkoutApplyCouponForm.clickToEnter",
            "Click here to enter your code"
          )}
        </button>
      </div>

      {isExpanded && (
        <form className="checkout-coupon__form" onSubmit={handleSubmit}>
          <div className="checkout-coupon__input-group">
            <input
              type="text"
              value={couponCode}
              onChange={(e) => setCouponCode(e.target.value)}
              placeholder={t("cartApplyCouponForm.placeholder", "Coupon code")}
              disabled={isApplying}
              className="checkout-coupon__input"
            />
            <button
              type="submit"
              className="checkout-coupon__submit-btn"
              disabled={isApplying}
            >
              {isApplying
                ? t("cartApplyCouponForm.applyingButton", "Applying...")
                : t("cartApplyCouponForm.applyButton", "Apply Coupon")}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default CheckoutApplyCouponForm;
